import { Box, Grid2 as Grid, useMediaQuery } from "@mui/material";
import styles from "./MostReadCard.module.scss";
import Image from "next/image";

const MostReadCard = (props) => {
  const isLightTheme = props?.theme === "light";
  const isSearchCard = props?.cardType === "search";

  const isSmallScreen = useMediaQuery("(min-width:600px)");

  return (
    <div onClick={props.onClick}>
      <div className={styles.divider}></div>

      <Box className={styles.cardWrapper}>
        <Grid container spacing={1} sx={{ width: "100%", height: "100%" }}>
          <Grid size={{ xs: 4.5, sm: 4, md: 4, lg: 4 }}>
            <div
              className={
                isSearchCard ? styles.searchImageWrapper : styles.imageWrapper
              }
            >
              <Image
                src={props?.image}
                unoptimized
                alt="Research Image"
                fill
                className={styles.image}
                style={{ objectFit: "cover" }}
                sizes={"100vw"}
                priority
              />
            </div>
          </Grid>
          <Grid
            size={{ xs: 7, sm: 4, md: 4, lg: 4 }}
            mt={0.25}
            sx={{
              paddingLeft: isSearchCard ? "10px" : "",
            }}
          >
            {isSmallScreen && (
              <p
                className={
                  isLightTheme
                    ? styles.researchDetailsLight
                    : styles.researchDetails
                }
              >
                {props?.researchDetails}
              </p>
            )}
            <p
              className={isLightTheme ? styles.titleLight : styles.title}
              style={isSearchCard ? { color: "#B9BBBD" } : {}}
            >
              {props?.title}
            </p>
            {!isSmallScreen && (
              <p
                className={
                  isLightTheme
                    ? styles.researchDetailsLight
                    : styles.researchDetails
                }
              >
                {props?.researchDetails}
              </p>
            )}
          </Grid>

          {isSmallScreen && (
            <Grid
              className={
                isLightTheme
                  ? styles.descriptionWrapperLight
                  : styles.descriptionWrapper
              }
              size={{ xs: 0, sm: 4, md: 4, lg: 4 }}
            >
              <p>{props?.description}</p>
            </Grid>
          )}
        </Grid>
      </Box>
    </div>
  );
};

export default MostReadCard;
